module.exports = {
  'Treffer': 'hit(s)',
  'Details': 'View',
  'reset_all': 'Reset all',
  'linktext': 'heidICON',
  'mehr': 'more',
  'Schließen': 'Close',
  'Persistente URL': 'Persistent URL',
  'Jahrzehnt': 's',
  'Jahrhundert': 'century',
  'Jahrtausend': 'millenium',
}



//////////////////
// WEBPACK FOOTER
// ./js/data/l10n/en-US.js
// module id = 13
// module chunks = 0